<template>
  <vonap-window width="432px" title="Send Exposure Chart" @close="closeForm" v-model="value">
    <v-card class="mx-auto">
      <v-card-text>
        <v-form @submit.prevent="sendExposureChart" ref="form">
          <v-text-field
            v-model="sendTo"
            type="email"
            label="To:"
            required
            :rules="[v => !!v || 'Email is required']"
          ></v-text-field>
          <v-text-field v-model="sendCc" type="email" label="CC:"></v-text-field>
          <v-text-field v-model="sendSubject" type="text" label="Subject:"></v-text-field>
          <v-textarea v-model="sendComments" label="Comments" counter="256"></v-textarea>
          <v-switch v-model="sendMeCopy" label="Send me a copy" />
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="blue primary" :disabled="sending">
              <v-progress-circular indeterminate v-if="sending" />
              Send
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import notification from '@/helpers/notification'
import VonapWindow from '@/components/VonapWindow'

export default {
  name: 'versionInfo',
  components: {
    VonapWindow,
  },
  props: ['clientId', 'value'],
  mounted() {
    this.getClientData()
  },
  data() {
    return {
      sending: false,
      sendTo: '',
      sendCc: '',
      sendSubject: 'FINMETRIX - Exposure Chart',
      sendComments: '',
      sendMeCopy: false,
    }
  },
  methods: {
    async getExposureChart() {
      const root = await kendo.drawing.drawDOM(kendo.jQuery('#exposureChartContainer'))
      const data = await kendo.drawing.exportImage(root)
      return this.dataURItoBlob(data)
    },
    dataURItoBlob(dataURI) {
      const binary = atob(dataURI.split(',')[1])
      const array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }

      return new Blob([new Uint8Array(array)], {type: 'image/png'})
    },
    async sendExposureChart(e) {
      this.sending = true

      let formData = new FormData(e.target)
      formData.append('ClientId', this.clientId)
      formData.append('SendTo', this.sendTo)
      formData.append('SendCc', this.sendCc)
      formData.append('SendSubject', this.sendSubject)
      formData.append('SendComments', this.sendComments)
      formData.append('SendMeCopy', this.sendMeCopy)
      formData.append('Url', location.origin)
      const exposureChart = await this.getExposureChart()
      formData.append('ExposureChart', exposureChart, 'exposureChart.png')

      const response = await axios({
        url: '/api/report/ExposureReport/sendExposureChart',
        method: 'post',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
      }).catch(() => {
        notification('Some error', 'error')
        this.sending = false
      })

      if (response.status == 200) {
        notification('Chart sent successfully')
      }

      this.sendCc = ''
      this.sendSubject = 'FINMETRIX - Exposure Chart'
      this.sendComments = ''
      this.sendMeCopy = false
      this.sending = false
      this.closeForm()
    },
    async getClientData() {
      const req = await axios
        .get('/api/config/client/getClient', {
          params: {
            clientId: this.clientId,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      let data = req.data
      this.sendTo = data.email
    },
    closeForm() {
      this.$emit('input', false)
    },
  },
}
</script>
